/** misc 分包业务文案 — 中文（按需 merge 进全局 i18n） */
export default {
  misc: {
    nav: {
      travelHub: '出行',
      travelSearch: '出行搜索',
      myOrders: '我的订单',
      orderSearch: '订单搜索',
      orderFill: '确认订单',
    },
    orderFill: {
      invalidTitle: '订单信息已失效',
      invalidDesc: '下单信息可能已过期，请返回重新选择商品后再试。',
      back: '返回',
    },
    date: {
      today: '今天',
      tomorrow: '明天',
      dayAfterTomorrow: '后天',
      monthDay: '{month}月{day}日',
      weekdaySun: '周日',
      weekdayMon: '周一',
      weekdayTue: '周二',
      weekdayWed: '周三',
      weekdayThu: '周四',
      weekdayFri: '周五',
      weekdaySat: '周六',
    },
    travelHub: {
      loading: '加载中…',
      domestic: '国内',
      international: '国际',
      locatedPrefix: '已定位到',
      switchToLocatedCity: '切换',
      priceStar: '价格星级',
      proximityPrefix: '您要到',
      proximityPlaceholder: '请输入位置',
      proximityMid: '附近',
      proximityRadius: '5km',
      proximitySuffix: '内的酒店吗？',
      searchHistory: '搜索记录',
      searchHotel: '查询酒店',
      searchTrain: '查询车票',
      searchFlight: '查询机票',
      flightDomestic: '机票',
      flightInternational: '国际机票',
      flightOneway: '单程',
      flightRoundtrip: '往返',
      flightMultiple: '多程',
      flightEconomy: '经济舱',
      flightBusiness: '公务/头等舱',
      flightAirline: '航空公司',
      noAirlineLimit: '不限航空公司',
      flightFromHint: '出发',
      flightToHint: '到达',
      trainTitle: '国内火车票预订',
      trainComingSoon: '火车票暂未开放，敬请期待',
      trainFromHint: '出发站',
      trainToHint: '到达站',
      trainHighSpeed: '高铁动车',
      tabOrders: '订单',
      unsupportedTitle: '当前环境不支持',
      unsupportedDesc: '请在云闪付或浏览器中打开此页面',
      errorTitle: '暂时无法跳转',
      errorDesc: '请确认已登录且手机号可用后重试',
      retry: '重试',
      comingSoon: '即将开放',
      locationFailedPrefix: '定位未成功，已默认',
      locating: '定位中…',
      trainNoService: '当前城市无火车票，请切换城市再试',
      flightNoService: '当前城市无机票，请切换城市再试',
      flightTipsTitle: '飞行贴士',
      flightTipsHint: '为您搜罗最全乘机指南',
      flightTipsMore: '更多',
      oneNight: '一天',
      nights: '{count}晚',
      guestsAdultsChildren: '{adult}成人{child}儿童',
      flightPassengers: '{adult}成人 {child}儿童 {infant}婴儿',
      roundtripDays: '{count}天',
      trainExpertTitle: '火车出行专家',
      selectDestCity: '请选择到达城市',
      sameOriginDest: '出发地和目的地不能相同',
      intlMainlandBoth: '国际机票出发地和目的地不能同时为中国大陆城市',
      selectCityFirst: '请先选择城市',
      addLeg: '添加行程',
      addLegTip: '最多可添加5程',
      selectCity: '请选择城市',
      delLegConfirm: '确定删除该行程吗？',
      withChild: '带儿童',
      withInfant: '带婴儿',
      childAgeRange: '2-12岁',
      infantAgeRange: '14天-2岁',
      selectPassengers: '选择乘机人',
      passengerAdult: '成人',
      passengerChild: '儿童',
      passengerInfant: '婴儿',
      passengerAdultDesc: '＞12周岁(含)',
      passengerChildDesc: '2-12周岁(不含)',
      passengerInfantDesc: '14天-2周岁(不含)',
      passengerDone: '完成',
      hotelScore: '{score}分',
      hotelDistance: '距您直线{distance}km',
      hotelPriceFrom: '起',
      hotelNoPrice: '暂无报价',
      hotelSearchPlaceholder: '位置/酒店',
      channel: {
        hotel: '酒店',
        train: '火车票',
        flight: '机票',
      },
      quickLink: {
        featured: '精选',
        topHotels: '上榜酒店',
        district: '商圈',
      },
      trainExpert: {
        trainChangeRefund: '退改无忧',
        trainQuickTicketIssuance: '急速出票',
        trainService: '7*24小时客服',
      },
    },
    travelSearch: {
      searchPlaceholder: '搜索{city}的酒店/位置',
      searching: '搜索中...',
      noResults: '未找到相关结果',
      noResultsHint: '换个关键词试试吧',
      searchHistory: '搜索记录',
      emptyHint: '输入关键词搜索酒店、地标或城市',
      cancel: '取消',
      citySection: '城市',
      poiSection: '地标',
      hotelSection: '酒店',
      scoreLabel: '分',
      priceFrom: '起',
      loadMore: '加载更多',
      hotelNearbyHint: '当前目的地及周边查询结果(酒店起价为参考价)',
      hotelOtherHint: '其他查询结果(酒店起价为参考价)',
      typeHotel: '酒店',
      typePoi: '地标',
      typeCity: '城市',
    },
    orderList: {
      searchOrders: '搜索订单',
      filter: '筛选',
      tab: {
        all: '全部',
        valid: '有效单',
        pendingPay: '待支付',
        refund: '退款单',
      },
      filterBookingTime: '预订时间',
      filterProductType: '产品类型',
      filterReset: '重置',
      filterConfirm: '确认',
      tabHome: '首页',
      tabOrders: '订单',
      combinedOrderFilter: '联合订单',
    },
    orderSearch: {
      placeholder: '输入城市名/订单号 搜索订单',
      historyTitle: '历史搜索',
      clearHistory: '清空',
      categoryTitle: '分类搜索',
    },
    orderPage: {
      orderType: {
        plane: '机票',
        intlPlane: '国际机票',
        hotel: '酒店',
        train: '火车票',
        combined: '联合订单',
        cart: '购物车订单',
      },
      metaTo: '至',
      departFrom: '出发',
      duration: '历时{duration}',
      nightsRooms: '{nights}晚{rooms}间',
      hotelTag: '酒店:',
      unionOrderBadge: '联合订单',
      bookAgain: '再次预订',
      cancelOrder: '取消订单',
      applyRefund: '申请退款',
      refundProgress: '退款进度',
      issueInvoice: '开发票',
      viewInvoice: '查看发票',
      goPay: '去支付',
      cartOrderItemCount: '共{count}件商品',
      refundPassengers: '退票的乘客',
      nextStep: '下一步',
      unsubscribe: '退订',
      unsubscribePlane: '退订机票',
      unsubscribePlaneDesc: '可一起退订附加产品',
      unsubscribeOr: '或单独退订以下产品',
      unsubscribeInsurance: '退订保险',
      trainInvoiceList: '火车票发票列表',
      invoiceFallback: '发票',
      invoiceAmount: '金额：￥{amount}',
      noTrainInvoice: '暂无火车票发票',
      selectInvoiceType: '选择发票类型',
      ticketInvoice: '机票发票',
      insuranceInvoice: '保险发票',
      insuranceInvoiceList: '保险发票列表',
      noInsuranceInvoice: '暂无保险发票',
      outbound: '去程',
      returnTrip: '返程',
      journeyLeg: '第{n}程',
      changePersonCount: '{count}人改签',
      hotelRefundPending:
        '该订单还未订房成功，如若取消订单，可能会产生手续费，可联系客服',
      hotelRefundPhone: '4007659936转1001',
      hotelRefundSuffix: '进行处理',
      pendingPayStatus: '待支付',
      loading: '加载中',
      toast: {
        noInvoiceData: '暂无发票数据',
        invoiceListFailed: '获取发票列表失败',
        noInsuranceInvoice: '暂无保险发票',
        insuranceInvoiceFailed: '获取保险发票失败',
        cancelSuccess: '取消成功',
        cancelFailed: '取消失败',
        deleteSuccess: '删除成功',
        refundSuccess: '申请退款成功',
        changingNoRefund: '改期中无法退款，需待改期完成 / 取消改期后，方可重新申请退款。',
        noRefundableTickets: '该订单无可退款的机票',
        noRefundableTicketProgress: '当前没有可退票的机票',
        confirmCancel: '是否取消订单',
        confirmDelete: '是否删除该订单',
        confirmTitle: '提示',
        cancelCombinedTitle: '取消联合订单',
        cancelCombinedMsg:
          '确定要取消该联合订单吗？取消后火车票/机票和酒店预订将一并取消。',
        confirmRefund: '确认退款',
        cancel: '取消',
        refundReason: '退票',
        interceptRefundApplyMsg:
          '提交拦截申请后，若为您拦截成功则会为您进行全额退款，若拦截失败，您可继续出行或重新发起退票申请。',
        cartOrderInvalid: '订单信息无效',
        cartOrderPayLinkFailed: '获取支付链接失败，请稍后重试',
      },
    },
  },
  components: {
    selectDate: {
      title: '选择日期',
      tips: '所选日期为出发地日期，变价频繁以实际支付价为准',
      invalidOrder: '所选日期不符合行程顺序要求',
    },
    waterFall: {
      loading: '加载中…',
      noMore: '没有更多了',
      unknownHotel: '未知酒店',
      tagFallback: '标签',
    },
    zeroLoading: {
      loading: '加载中…',
      wait: '请稍候',
    },
  },
  unionPoint: {
    orderFill: {
      title: '云闪付积点抵值',
      unavailable: '暂不可用',
      balanceHint: '余额 {count} 积点',
      inputPlaceholder: '最多可用 {count} 积点',
      useMax: '全部使用',
      unit: '积点',
      rulesTitle: '使用规则',
      ruleOffset: '兑换比例 {ratio}',
      ruleMax: '单笔最高抵扣 {amount} 元',
      ruleMinUse: '最少使用 {count} 积点',
      unavailableOverSaleprice: '订单金额需超过 {amount} 元才可使用积点',
      inputMinHint: '使用积点最少需 {count} 积点',
      calculating: '计算中…',
      deductLine: '云闪付积点抵值',
      deductWithRate: '云闪付积点抵值: 1 积点可抵 {amount} 元',
      priceDetailLine: '云闪付积点抵值',
    },
    redemptionRules: {
      link: '《吉乐游云闪付积点兑换规则》',
      title: '吉乐游云闪付积点兑换规则',
      sections: [
        {
          title: '一、功能说明',
          paragraphs: [
            '"云闪付积点兑换" 是吉乐游联合云闪付推出的支付抵扣功能。用户在吉乐游平台下单时，可使用本人云闪付账户内的积点抵扣订单金额，抵扣后的剩余应付金额还可享受信用卡免息分期。',
          ],
        },
        {
          title: '二、积点来源与免责声明',
          paragraphs: [
            '本功能所消耗的积点，为用户本人云闪付 APP 账户内的积点资产，兑换时将实时从用户云闪付账户中扣除。',
            '积点的获取方式、余额查询、有效期、账户状态等均以云闪付官方规则为准，吉乐游不参与积点的发放与管理。',
            '吉乐游仅提供积点兑换抵扣通道，不对积点本身的归属、有效性、有效期及账户异常承担责任。',
            '请用户在兑换前确认本人云闪付积点余额及兑换意愿，一经确认兑换，积点即时扣除不可撤销（退款场景除外）。',
          ],
        },
        {
          title: '三、适用场景与抵扣展示',
          paragraphs: [
            '吉乐游平台全场景支持积点兑换，包括但不限于机票、酒店、门票等商品及服务。',
            '用户在订单结算页，系统将根据当前积点余额自动计算并展示可抵扣金额，用户无需手动换算。',
            '单笔订单最高抵扣 100 元，实际可抵扣金额以结算页展示为准。',
          ],
        },
        {
          title: '四、兑换方式',
          paragraphs: [
            '用户在订单结算页可自主选择是否使用积点抵扣，以及具体抵扣金额（不超过系统展示的可抵扣上限）。',
            '实际可抵扣金额受以下两者中最低值限制：',
          ],
          listItems: [
            '系统根据积点余额计算的可抵扣金额（含单笔 100 元上限）',
            '用户云闪付账户当前积点余额',
          ],
          paragraphsAfter: [
            '积点余额不足时，按实际可抵扣金额执行，不影响订单正常支付。',
            '确认使用积点兑换后，对应积点实时从云闪付账户扣除。',
          ],
        },
        {
          title: '五、信用卡免息分期',
          paragraphs: [
            '积点抵扣后的剩余应付金额，可享受信用卡免息分期。',
            '吉乐游平台所有场景均支持免息分期，具体可分期数以商品详情页 / 结算页展示为准。',
          ],
        },
        {
          title: '六、使用规则与限制',
          paragraphs: [
            '次数限制：每人每日最多可使用积点兑换 3 次。',
            '金额上限：单笔订单积点抵扣最高不超过 100 元。',
            '优惠叠加：积点抵扣可与平台其他优惠（满减、优惠券、活动折扣等）叠加使用。',
          ],
        },
        {
          title: '七、退款说明',
          paragraphs: [
            '订单发生全额退款时，已扣除的积点将原路退回至用户云闪付账户。',
            '订单发生部分退款时，按实际退款金额占订单总金额的比例，对应回退积点。',
            '积点退回到账时间以云闪付系统处理时效为准，通常为 1-3 个工作日。',
          ],
        },
        {
          title: '八、温馨提示',
          paragraphs: [
            '积点为云闪付账户资产，请妥善保管云闪付账户信息，因账户被盗用、转借等产生的积点损失由用户自行承担。',
            '因云闪付系统维护、升级或故障导致积点扣除失败、延迟或异常的，吉乐游不承担责任，但将协助用户与云闪付沟通处理。',
            '本规则未尽事宜，以云闪付官方积点规则及吉乐游平台相关协议为准。',
            '吉乐游有权根据业务调整变更本规则，变更后将在平台公示，用户继续使用即视为同意变更后的规则。',
          ],
        },
      ],
    },
  },
}
